export class Content {
    articleId: string;
    content: string;
    title: string;
}

export class ImageSnippet {
    constructor(public src: string, public file: File) { }
}
